<!-- version 2021/05/20 -->
<template>
  <a
    class="btn"
    @click="desideQuoteMessage()"
  >{{ title }}</a>
</template>

<script>
import { eventBus } from "@/utility/event-bus";

export default {
  props: {
    title: String
  },
  methods: {
    desideQuoteMessage() {
      eventBus.decideQuote();
    }
  }
};
</script>

<style lang="sass" scoped>
    a
        border-radius: 6px !important
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
        background-color: #28c3cd !important
        color: #FFF !important
</style>